<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-dialog
		persistent
		v-model="showDialog"
		width="500">
		<v-card>
			<v-form ref="form">
				<v-card-title
					class="headline"
					primary-title
				>
					{{this.edit? "Edycja wniosku o podpisanie aneksu" : "Dołączenie wniosku o podpisanie aneksu"}}
				</v-card-title>
				<v-card-text>
					<v-flex xs12>
						<v-text-field
							browser-autocomplete="off"
							label="Numer aneksu"
							aria-label="annex number"
							for="annex-application-popup-number"
							id="annex-application-popup-number"
							:rules="rules"
							v-model="application.number">
						</v-text-field>
					</v-flex>
					<v-flex xs12 mb-3>
						<v-menu
							ref="menu"
							v-model="menu"
							:close-on-content-click="false"
							:return-value.sync="application.signDate"
							transition="scale-transition"
							offset-y
							full-width
							min-width="290px"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									browser-autocomplete="off"
									v-model="application.signDate"
									label="Data podpisania wniosku"
									aria-label="application sign date"
									for="annex-application-popup-sign-date"
									id="annex-application-popup-sign-date"
									:rules="rules"
									prepend-icon="event"
									readonly
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker :first-day-of-week="1"
								v-model="application.signDate" no-title scrollable locale="pl-PL">
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="menu = false">Anuluj</v-btn>
								<v-btn text color="primary" @click="$refs.menu.save(application.signDate)">OK</v-btn>
							</v-date-picker>
						</v-menu>
					</v-flex>
					<div v-if="!edit">
						<v-flex xs12>
							<v-layout row>
								<v-flex xs6>
									<v-btn @click="$refs.file.click()" class="ma-2">
										{{application.file ? 'Podmień wniosek' : 'Dodaj wniosek'}}
									</v-btn>
								</v-flex>
								<v-flex xs6>
									<v-btn @click="$refs.attachments.click()" class="ma-2">
										{{"Dodaj załączniki"}}
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
						<input :rules="rules" type="file" ref="file" id="application-file-input" v-show="false"
							:accept="acceptedFiles"
							v-on:change="handleApplicationUpload">
						<input :rules="rules" type="file" multiple v-show="false" ref="attachments"
							:accept="acceptedFiles"
							id="application-attachments-input"
							v-on:change="handleAttachmentsUpload">

						<div v-if="application.file">
							<strong class="mr-2">Wniosek: </strong>{{application.file.name}}
							<v-icon @click="deleteApplicationFile" style="cursor: pointer" class="ml-2" color="red">delete</v-icon>
						</div>
						<div v-for="(item, index) in application.attachments" :key="index">
							<strong class="mr-2">{{'Załącznik ' + (index + 1)}}:</strong>
							{{item.name}}
							<v-icon @click="deleteAttachment(index)" style="cursor: pointer" class="ml-2" color="red">delete
							</v-icon>
						</div>
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="!edit"
						color="primary"
						@click="addAnnexApplication"
					>
						Zapisz
					</v-btn>
					<v-btn
						v-else
						color="primary"
						@click="updateAnnexApplication">
						Zapisz
					</v-btn>
					<v-btn
						color="primary"
						flat
						@click="closeModal">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-form>

		</v-card>
	</v-dialog>
</template>

<script>
	import {Files} from "../../../../utils/Files";
	import {Annex} from "@/api/generated/Annex";

	export default {

		name: "AnnexApplicationPopup",

		data() {
			return {
				showDialog: this.isOpen,
				application: {
					number: null,
					signDate: null,
					file: null,
					attachments: [],
				},
				menu: false,
				fileChanged: false,

				rules: [v => !!v || "Pole wymagane!"],
			};
		},

		methods: {
			closeModal() {
				this.$refs.form.reset();
				if (!this.edit) {
					this.$refs.file.value = "";
				}
				this.application = {
					number: null,
					signDate: null,
					file: null,
					attachments: [],
				};
				this.$emit("close");
			},
			async addAnnexApplication() {
				if (!await this.$refs.form.validate() || (this.application.file === null)) {
					return;
				}
				let formData = new FormData();
				formData.append("file", this.application.file);
				for (let i = 0; i < this.application.attachments.length; ++i) {
					formData.append("attachments", this.application.attachments[i]);
				}
				await this.$http.post(process.env.VUE_APP_API_URL + "/annex/application?projectId="
					.concat(this.$route.params.projectId)
					.concat("&number=" + this.application.number)
					.concat("&signDate=" + this.application.signDate)
					.concat("&fileChanged=" + this.application.fileChanged), formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				this.$emit("refresh");
				this.closeModal();
			},

			async updateAnnexApplication() {
				if (!await this.$refs.form.validate()) {
					return;
				}
				await Annex.putApplicationData(this, this.$route.params.projectId, this.item.id, this.application.signDate, this.application.number,
					successResponse => {
						this.$messagesBus.$emit("success", "Wniosek został zaktualizowany", successResponse);
						this.$emit("refresh");
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zaktualizować wniosku", errorResponse);
					});


				this.closeModal();
			},
			async handleApplicationUpload () {
				if (this.hasIncorrectFilesExtension(this.$refs.file.files)) {
					Files.methods.clearFileInput('application-file-input');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.file.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput('application-file-input');
					return;
				}
				this.application.file = this.$refs.file.files[0];
			},

			async handleAttachmentsUpload () {
				if (this.hasIncorrectFilesExtension(this.$refs.attachments.files)) {
					Files.methods.clearFileInput('application-attachments-input');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}

				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.attachments.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput("application-attachments-input");
					return;
				}
				for (let i = 0; i < this.$refs.attachments.files.length; ++i) {
					this.application.attachments.push(this.$refs.attachments.files[i]);
				}
			},
			deleteApplicationFile () {
				this.application.file = null;
			},
			deleteAttachment (index) {
				this.application.attachments.splice(index, 1);
			},
		},

		watch: {
			isOpen: {
				immediate: true,
				handler(val) {
					this.showDialog = val;
					this.application.number = this.item.number;
					this.application.signDate = this.item.applicationSignDate;
					if (this.item.application !== undefined) {
						this.application.file = this.item.application.fileName;
					}
				},
			},
		},


		props: {
			isOpen: {type: Boolean, default: false},
			edit: {type: Boolean, default: false},
			item: {
				type: Object, default() {
					return {};
				},
			},
		},
	};
</script>

<style scoped>

</style>
